import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const convertFormatDate = ({ date, format = "YYYY-MM-DD HH:mm:ss" }) => {
  try {
    const formattedTime1 = dayjs(date).utc().format(format);
    // const formattedTime2 = dayjs(date).tz("Asia/Bangkok").format(format);
    // console.log("formatted utc :>> ", formattedTime1);
    // console.log("formatted tz Asia/Bangkok:>> ", formattedTime2);

    return formattedTime1;
  } catch (error) {
    console.log("error :>> ", error);
    return date;
  }
};
